import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  fullWidth?: boolean;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-3 text-sm font-bold uppercase tracking-wider transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uncommon-gold disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-white text-black hover:bg-uncommon-gold hover:text-black border-2 border-transparent',
    secondary: 'bg-transparent text-white border-2 border-white hover:border-uncommon-gold hover:text-uncommon-gold'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-144">
      {children}
    </motion.button>;
}